/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.filters.module.ts" />

module App.Common.Filters {
	'use strict';

	function filter(input: number): string {
		if (!input) {
			return '';
		}
		if (!/^\d{4}$/.test(input.toString())) {
			return input.toString();
		}
		return `${input}/${(input + 1).toString().substr(2)}`;
	}

	angular
		.module('app.common.filters')
		.filter('financialYear', [() => {return filter;}]);
}